import React, { useState } from 'react';
import { Input, Select, SelectItem } from "@heroui/react";
import { Icon } from "@iconify/react";

const STATUS_OPTIONS = [
    "Cerrado",
    "Finiquito Firmado", 
    "Juicio Chile",
    "Juicio Perú",
    "Reclamado"
];

const StatusSelect = ({ label, value, onChange, isReadOnly = false, icon = "lucide:hash", errorMessage, classNames }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleSelectionChange = (keys) => {
        const selectedKey = Array.from(keys)[0];
        if (selectedKey) {
            onChange(selectedKey);
        }
        setIsOpen(false);
    };

    // Si el valor no está en las opciones predefinidas Y estamos en modo solo lectura, mostrar un Input
    if (value && !STATUS_OPTIONS.includes(value) && isReadOnly) {
        return (
            <div className="w-full">
                <Input
                    label={label}
                    value={value}
                    isReadOnly={true}
                    startContent={<Icon icon={icon} className="text-default-400 pointer-events-none flex-shrink-0" />}
                    classNames={{
                        label: classNames?.label || "text-sm font-medium",
                        input: classNames?.input || "text-sm",
                    }}
                />
                {errorMessage && (
                    <p className="text-danger text-xs mt-1">{errorMessage}</p>
                )}
            </div>
        );
    }

    return (
        <div className="w-full">
            <Select
                label={label}
                selectedKeys={value ? [value] : []}
                onSelectionChange={handleSelectionChange}
                isOpen={isOpen}
                onOpenChange={setIsOpen}
                isDisabled={isReadOnly}
                startContent={<Icon icon={icon} className="text-default-400 pointer-events-none flex-shrink-0" />}
                classNames={{
                    label: classNames?.label || "text-sm font-medium",
                    trigger: classNames?.trigger || "h-12",
                    value: classNames?.value || "text-sm",
                }}
                popoverProps={{
                    placement: "bottom-start",
                    offset: 4,
                }}
                placeholder="Seleccionar status"
            >
                {STATUS_OPTIONS.map((option) => (
                    <SelectItem key={option} value={option}>
                        {option}
                    </SelectItem>
                ))}
            </Select>
            
            {errorMessage && (
                <p className="text-danger text-xs mt-1">{errorMessage}</p>
            )}
        </div>
    );
};

export default StatusSelect; 